var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { LoadingButton } from "@mui/lab";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { CloudinaryService } from "../services/cloudinary.service";
import { getScaledUrl, MediaSize } from "../utils/media.util";
import { useReadOnly } from "../utils/hooks/users/useReadOnly";
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import CropFreeIcon from '@mui/icons-material/CropFree';
import CropLandscapeIcon from '@mui/icons-material/CropLandscape';
import CropPortraitIcon from '@mui/icons-material/CropPortrait';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import OpacityIcon from '@mui/icons-material/Opacity';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { alpha, useTheme } from '@mui/material/styles';
import NewStatusPicker from './NewStatusPicker';
import SimpleDialog from './SimpleDialog';
export var ALL_IMAGE_UPLOAD_RATIOS = [
    'free',
    'landscape',
    'portrait',
    'square',
];
var ALLOWED_TYPES = ['.png', '.jpg', '.jpeg'];
var SVG_TYPE = 'image/svg+xml';
var ACCEPTED_RASTER_TYPES = ['image/png', 'image/jpeg'];
var RATIO_ASPECTS = {
    free: undefined,
    square: 1,
    landscape: 16 / 9,
    portrait: 9 / 16,
};
var RATIO_LABELS = {
    free: 'Freeform',
    landscape: 'Landscape',
    portrait: 'Portrait',
    square: 'Square',
};
var RATIO_ICONS = {
    free: CropFreeIcon,
    landscape: CropLandscapeIcon,
    portrait: CropPortraitIcon,
    square: CropSquareIcon,
};
// Shown instead of the picker when a field allows only one ratio
var RATIO_HINTS = {
    free: 'This image can be cropped to any shape.',
    landscape: 'This image is cropped to landscape format (16:9).',
    portrait: 'This image is cropped to portrait format (9:16).',
    square: 'This image is cropped to a square (1:1).',
};
var TRANSPARENCY_PATTERN = "\n    linear-gradient(45deg, rgba(71, 85, 105, 0.22) 25%, transparent 25%),\n    linear-gradient(-45deg, rgba(71, 85, 105, 0.22) 25%, transparent 25%),\n    linear-gradient(45deg, transparent 75%, rgba(71, 85, 105, 0.22) 75%),\n    linear-gradient(-45deg, transparent 75%, rgba(71, 85, 105, 0.22) 75%)\n";
var PREVIEW_BACKGROUNDS = ['pattern', 'dark', 'light'];
var PREVIEW_BACKGROUND_STYLES = {
    pattern: {
        bgcolor: '#F8FAFC',
        backgroundImage: TRANSPARENCY_PATTERN,
    },
    dark: {
        bgcolor: '#111',
        backgroundImage: 'none',
    },
    light: {
        bgcolor: '#fff',
        backgroundImage: 'none',
    },
};
var getInitialCrop = function (ratio, width, height) {
    var aspect = RATIO_ASPECTS[ratio];
    if (!aspect) {
        return { unit: '%', x: 0, y: 0, width: 100, height: 100 };
    }
    return centerCrop(makeAspectCrop({ unit: '%', width: 90 }, aspect, width, height), width, height);
};
var cropsMatch = function (first, second) {
    if (!first || !second || first.unit !== second.unit)
        return false;
    return Math.abs(first.x - second.x) < 0.01
        && Math.abs(first.y - second.y) < 0.01
        && Math.abs(first.width - second.width) < 0.01
        && Math.abs(first.height - second.height) < 0.01;
};
// Uploads are optimized internally (invisible to the user): the crop is
// downscaled to a sane resolution and re-encoded as jpeg unless the source
// png actually uses transparency.
var MAX_OUTPUT_DIMENSION = 2560;
var usesTransparency = function (ctx, width, height) {
    var data = ctx.getImageData(0, 0, width, height).data;
    for (var i = 3; i < data.length; i += 4) {
        if (data[i] < 255)
            return true;
    }
    return false;
};
var cropToBlob = function (src, area, type) { return __awaiter(void 0, void 0, void 0, function () {
    var img, scale, width, height, canvas, ctx, outputType;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                img = new Image();
                return [4 /*yield*/, new Promise(function (resolve, reject) {
                        img.onload = resolve;
                        img.onerror = reject;
                        img.src = src;
                    })];
            case 1:
                _a.sent();
                scale = Math.min(1, MAX_OUTPUT_DIMENSION / Math.max(area.width, area.height));
                width = Math.round(area.width * scale);
                height = Math.round(area.height * scale);
                canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                ctx = canvas.getContext('2d');
                ctx.imageSmoothingQuality = 'high';
                ctx.drawImage(img, area.x, area.y, area.width, area.height, 0, 0, width, height);
                outputType = type === 'image/png' && usesTransparency(ctx, width, height)
                    ? 'image/png'
                    : 'image/jpeg';
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        return canvas.toBlob(function (blob) { return blob ? resolve(blob) : reject(new Error('Crop failed')); }, outputType, 0.85);
                    })];
        }
    });
}); };
var ImageUploadField = function (_a) {
    var image = _a.image, setImage = _a.setImage, width = _a.width, height = _a.height, _b = _a.ratio, ratio = _b === void 0 ? 'free' : _b, ratioOptions = _a.ratioOptions, id = _a.id, disabled = _a.disabled, compact = _a.compact, _c = _a.supportSvg, supportSvg = _c === void 0 ? false : _c;
    var availableRatios = (ratioOptions === null || ratioOptions === void 0 ? void 0 : ratioOptions.length) ? ratioOptions : [ratio];
    var allowedTypes = supportSvg ? __spreadArray(__spreadArray([], ALLOWED_TYPES, true), ['.svg'], false) : ALLOWED_TYPES;
    var acceptedFileTypes = supportSvg
        ? __spreadArray(__spreadArray([], ACCEPTED_RASTER_TYPES, true), [SVG_TYPE], false).join(',')
        : ACCEPTED_RASTER_TYPES.join(',');
    var initialRatio = availableRatios.includes(ratio) ? ratio : availableRatios[0];
    var configuredAspect = RATIO_ASPECTS[ratio];
    var t = useTranslation().t;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var readOnly = useReadOnly();
    var isDisabled = disabled || readOnly;
    var theme = useTheme();
    var cropFullScreen = useMediaQuery(theme.breakpoints.down('md'));
    var inputRef = useRef(null);
    var _d = useState(false), dragActive = _d[0], setDragActive = _d[1];
    var _e = useState(null), source = _e[0], setSource = _e[1];
    var _f = useState(), crop = _f[0], setCrop = _f[1];
    var _g = useState(), initialCrop = _g[0], setInitialCrop = _g[1];
    var _h = useState(initialRatio), activeRatio = _h[0], setActiveRatio = _h[1];
    var _j = useState(false), uploading = _j[0], setUploading = _j[1];
    var _k = useState(), previewAspect = _k[0], setPreviewAspect = _k[1];
    var _l = useState('pattern'), previewBackground = _l[0], setPreviewBackground = _l[1];
    var _m = useState(false), fullPreviewOpen = _m[0], setFullPreviewOpen = _m[1];
    var _o = useState(false), confirmDiscard = _o[0], setConfirmDiscard = _o[1];
    var imgRef = useRef(null);
    var activeAspect = RATIO_ASPECTS[activeRatio];
    var ActiveRatioIcon = RATIO_ICONS[activeRatio];
    var explicitFieldAspect = typeof width === 'number' && typeof height === 'number'
        ? width / height
        : undefined;
    var fieldAspect = configuredAspect || explicitFieldAspect || (!width && !height ? 1 : undefined);
    var uploadSvg = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var response, sanitizedUrl, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    setUploading(true);
                    return [4 /*yield*/, CloudinaryService.upload(file)];
                case 1:
                    response = _b.sent();
                    if (!(response === null || response === void 0 ? void 0 : response.secure_url)) {
                        throw new Error(((_a = response === null || response === void 0 ? void 0 : response.error) === null || _a === void 0 ? void 0 : _a.message) || 'Upload failed');
                    }
                    sanitizedUrl = CloudinaryService.getSanitizedSvgDeliveryUrl(response.secure_url);
                    setImage === null || setImage === void 0 ? void 0 : setImage({
                        mediaURI: sanitizedUrl,
                        publicId: response.public_id,
                        provider: 'cloudinary',
                        mediaFormat: response.format || 'svg',
                    });
                    enqueueSnackbar(t('Image uploaded successfully'), { variant: 'success' });
                    return [3 /*break*/, 4];
                case 2:
                    e_1 = _b.sent();
                    console.error(e_1);
                    enqueueSnackbar(t('Image upload failed'), { variant: 'error' });
                    return [3 /*break*/, 4];
                case 3:
                    setUploading(false);
                    if (inputRef.current)
                        inputRef.current.value = '';
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var openFile = function (file) {
        var isSvg = file.type === SVG_TYPE || file.name.toLowerCase().endsWith('.svg');
        var isSupportedRaster = ACCEPTED_RASTER_TYPES.includes(file.type);
        if (!isSupportedRaster && !(supportSvg && isSvg))
            return;
        if (isSvg) {
            void uploadSvg(file);
            return;
        }
        setActiveRatio(initialRatio);
        setCrop(undefined);
        setInitialCrop(undefined);
        setSource({ url: URL.createObjectURL(file), type: file.type });
    };
    var onImageLoad = function (e) {
        var _a = e.currentTarget, width = _a.width, height = _a.height;
        var nextCrop = getInitialCrop(activeRatio, width, height);
        setCrop(nextCrop);
        setInitialCrop(nextCrop);
    };
    var resetCrop = function (nextRatio) {
        if (nextRatio === void 0) { nextRatio = activeRatio; }
        var img = imgRef.current;
        if (!(img === null || img === void 0 ? void 0 : img.width) || !(img === null || img === void 0 ? void 0 : img.height))
            return;
        var nextCrop = getInitialCrop(nextRatio, img.width, img.height);
        setCrop(nextCrop);
        setInitialCrop(nextCrop);
    };
    var handleRatioChange = function (nextRatio) {
        setActiveRatio(nextRatio);
        resetCrop(nextRatio);
    };
    var cropCanBeReset = !!crop && !!initialCrop && !cropsMatch(crop, initialCrop);
    // The crop selection is in % of the displayed image; upload needs pixels of the natural image.
    var getPixelArea = function () {
        var img = imgRef.current;
        if (!img || !(crop === null || crop === void 0 ? void 0 : crop.width) || !(crop === null || crop === void 0 ? void 0 : crop.height))
            return null;
        var px = crop.unit === '%'
            ? {
                x: crop.x * img.width / 100,
                y: crop.y * img.height / 100,
                width: crop.width * img.width / 100,
                height: crop.height * img.height / 100,
            }
            : crop;
        var scaleX = img.naturalWidth / img.width;
        var scaleY = img.naturalHeight / img.height;
        return {
            x: Math.round(px.x * scaleX),
            y: Math.round(px.y * scaleY),
            width: Math.round(px.width * scaleX),
            height: Math.round(px.height * scaleY),
        };
    };
    var closeDialog = function () {
        if (source)
            URL.revokeObjectURL(source.url);
        setSource(null);
        if (inputRef.current)
            inputRef.current.value = '';
    };
    var handleDrop = function (e) {
        var _a;
        e.preventDefault();
        setDragActive(false);
        if (isDisabled)
            return;
        var file = (_a = e.dataTransfer.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file)
            openFile(file);
    };
    var handleUpload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var area, blob, response, e_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    area = getPixelArea();
                    if (!source || !area)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    setUploading(true);
                    return [4 /*yield*/, cropToBlob(source.url, area, source.type)];
                case 2:
                    blob = _b.sent();
                    return [4 /*yield*/, CloudinaryService.upload(blob)];
                case 3:
                    response = _b.sent();
                    if (!(response === null || response === void 0 ? void 0 : response.secure_url)) {
                        throw new Error(((_a = response === null || response === void 0 ? void 0 : response.error) === null || _a === void 0 ? void 0 : _a.message) || 'Upload failed');
                    }
                    setImage === null || setImage === void 0 ? void 0 : setImage({
                        mediaURI: response.secure_url,
                        publicId: response.public_id,
                        provider: 'cloudinary'
                    });
                    enqueueSnackbar(t('Image uploaded successfully'), { variant: 'success' });
                    closeDialog();
                    return [3 /*break*/, 6];
                case 4:
                    e_2 = _b.sent();
                    console.error(e_2);
                    enqueueSnackbar(t('Image upload failed'), { variant: 'error' });
                    return [3 /*break*/, 6];
                case 5:
                    setUploading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var previewUrl = getScaledUrl(image, MediaSize.LARGE_600, MediaSize.LARGE_600);
    var fullPreviewUrl = getScaledUrl(image);
    var cyclePreviewBackground = function () {
        setPreviewBackground(function (current) {
            var currentIndex = PREVIEW_BACKGROUNDS.indexOf(current);
            return PREVIEW_BACKGROUNDS[(currentIndex + 1) % PREVIEW_BACKGROUNDS.length];
        });
    };
    useEffect(function () {
        setPreviewAspect(undefined);
    }, [previewUrl]);
    var cropDialog = (_jsxs(Dialog, __assign({ open: !!source, 
        // Outside clicks and Escape would lose the picked image, so they ask first; ✕ and Cancel close directly
        onClose: function () { return !uploading && setConfirmDiscard(true); }, maxWidth: 'lg', fullWidth: true, fullScreen: cropFullScreen }, { children: [_jsxs(DialogTitle, __assign({ sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1.5 } }, { children: [t('Crop image'), _jsx(IconButton, __assign({ "aria-label": t('Close'), onClick: closeDialog, disabled: uploading }, { children: _jsx(CloseIcon, { fontSize: 'small' }) }))] })), _jsx(DialogContent, { children: _jsxs(Stack, __assign({ gap: 2, sx: { minHeight: '100%' } }, { children: [availableRatios.length > 1 ? (_jsxs(Stack, __assign({ gap: 1 }, { children: [_jsx(Typography, __assign({ variant: 'subtitle2', color: 'text.secondary' }, { children: t('Aspect ratio') })), _jsx(NewStatusPicker, { value: activeRatio, onChange: handleRatioChange, disabled: uploading, ariaLabel: t('Aspect ratio'), options: availableRatios.map(function (ratioOption) {
                                        var RatioIcon = RATIO_ICONS[ratioOption];
                                        var label = t(RATIO_LABELS[ratioOption]);
                                        return {
                                            value: ratioOption,
                                            label: (_jsxs(Stack, __assign({ component: 'span', direction: 'row', alignItems: 'center', gap: 0.75 }, { children: [_jsx(Box, __assign({ component: 'span', sx: {
                                                            display: 'none',
                                                            '@media (min-width: 480px)': { display: 'inline' },
                                                        } }, { children: label })), _jsx(RatioIcon, { sx: { fontSize: 20, flexShrink: 0 } })] }))),
                                        };
                                    }), sx: {
                                        width: '100%',
                                        '& .MuiToggleButtonGroup-grouped': {
                                            flex: 1,
                                            minWidth: 0,
                                        },
                                    } })] }))) : (_jsx(Alert, __assign({ severity: 'info', icon: _jsx(ActiveRatioIcon, { fontSize: 'inherit' }) }, { children: t(RATIO_HINTS[activeRatio]) }))), _jsx(Box, __assign({ sx: {
                                flex: 1,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                minHeight: 320,
                                borderRadius: 1,
                                overflow: 'hidden',
                                bgcolor: 'grey.900',
                            } }, { children: source &&
                                _jsx(ReactCrop, __assign({ crop: crop, onChange: function (pixelCrop, percentCrop) { return setCrop(percentCrop); }, aspect: activeAspect, keepSelection: true }, { children: _jsx("img", { ref: imgRef, src: source.url, alt: '', onLoad: onImageLoad, style: {
                                            display: 'block',
                                            maxWidth: '100%',
                                            // The height the title, ratio controls and footer leave, plus the dialog margins outside fullscreen
                                            maxHeight: "calc(100dvh - ".concat(cropFullScreen ? 236 : 300, "px)"),
                                        } }) })) }))] })) }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ startIcon: _jsx(RestartAltIcon, {}), "aria-label": t('Reset crop'), onClick: function () { return resetCrop(); }, disabled: uploading || !cropCanBeReset, "aria-hidden": !cropCanBeReset, tabIndex: cropCanBeReset ? 0 : -1, sx: {
                            mr: 'auto',
                            minWidth: { xs: 0, sm: 64 },
                            visibility: cropCanBeReset ? 'visible' : 'hidden',
                            pointerEvents: cropCanBeReset ? 'auto' : 'none',
                            // Phones keep the icon only: the label does not fit beside Cancel and Upload in every language
                            '& .MuiButton-startIcon': { ml: { xs: 0, sm: -0.5 }, mr: { xs: 0, sm: 1 } },
                        } }, { children: _jsx(Box, __assign({ component: 'span', sx: { display: { xs: 'none', sm: 'inline' } } }, { children: t('Reset crop') })) })), _jsx(Button, __assign({ onClick: closeDialog, disabled: uploading }, { children: t('Cancel') })), _jsx(LoadingButton, __assign({ variant: 'contained', loading: uploading, disabled: !(crop === null || crop === void 0 ? void 0 : crop.width) || !(crop === null || crop === void 0 ? void 0 : crop.height), onClick: handleUpload }, { children: t('Upload') }))] })] })));
    var discardDialog = (_jsx(SimpleDialog, { open: confirmDiscard, title: t('Discard this image?'), message: t('It has not been uploaded yet.'), confirmText: t('Discard'), cancelText: t('Keep editing'), onClose: function () { return setConfirmDiscard(false); }, onConfirm: function () {
            setConfirmDiscard(false);
            closeDialog();
        } }));
    var fullPreviewDialog = (_jsxs(Dialog, __assign({ open: fullPreviewOpen && !!fullPreviewUrl, onClose: function () { return setFullPreviewOpen(false); }, fullScreen: true, BackdropProps: {
            sx: {
                bgcolor: 'rgba(2, 6, 23, 0.82)',
                backdropFilter: 'blur(12px)',
            },
        }, PaperProps: {
            sx: {
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxSizing: 'border-box',
                p: { xs: 2, sm: 3 },
                pt: { xs: 8, sm: 9 },
                bgcolor: 'transparent',
                backgroundImage: 'none',
                boxShadow: 'none',
                overflow: 'hidden',
            },
        } }, { children: [_jsx(IconButton, __assign({ "aria-label": t('Close'), onClick: function () { return setFullPreviewOpen(false); }, sx: {
                    position: 'absolute',
                    top: { xs: 16, sm: 24 },
                    right: { xs: 16, sm: 24 },
                    zIndex: 1,
                    color: 'common.white',
                    bgcolor: 'rgba(17, 17, 17, 0.72)',
                    '&:hover': {
                        bgcolor: 'rgba(17, 17, 17, 0.9)',
                    },
                } }, { children: _jsx(CloseIcon, {}) })), _jsx(Box, __assign({ sx: [
                    {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        backgroundPosition: '0 0, 0 6px, 6px -6px, -6px 0',
                        backgroundSize: '12px 12px',
                        overflow: 'hidden',
                    },
                    PREVIEW_BACKGROUND_STYLES[previewBackground],
                ] }, { children: _jsx(Box, { component: 'img', src: fullPreviewUrl, alt: '', sx: {
                        display: 'block',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                    } }) }))] })));
    var previewActionSx = {
        borderRadius: 1,
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'grey.200',
        '&:hover': {
            bgcolor: 'grey.100',
        },
    };
    var previewActionInset = 12;
    return (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ id: id, role: 'button', tabIndex: isDisabled || uploading ? -1 : 0, "aria-label": t('Add image'), "aria-disabled": isDisabled || uploading, "aria-busy": uploading, onClick: function () { var _a; return !isDisabled && !uploading && ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click()); }, onKeyDown: function (e) {
                    var _a;
                    if (e.target !== e.currentTarget)
                        return;
                    if (!isDisabled && !uploading && (e.key === 'Enter' || e.key === ' ')) {
                        e.preventDefault();
                        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
                    }
                }, onDragOver: function (e) {
                    e.preventDefault();
                    if (!isDisabled && !uploading)
                        setDragActive(true);
                }, onDragLeave: function () { return setDragActive(false); }, onDrop: handleDrop, sx: __assign(__assign(__assign({ position: 'relative' }, (configuredAspect && !width
                    ? { height: height || 230, aspectRatio: "".concat(configuredAspect), alignSelf: 'flex-start' }
                    : { width: width || 230, height: height || 230 })), { border: previewUrl ? '1px solid' : 'none', borderColor: 'grey.200', borderRadius: 1, boxSizing: 'border-box', bgcolor: dragActive
                        ? function (theme) { return alpha(theme.palette.primary.main, 0.04); }
                        : 'background.paper', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: isDisabled || uploading ? 'default' : 'pointer', transition: 'background-color 150ms, border-color 150ms', overflow: 'hidden' }), (!isDisabled && !uploading && {
                    '&:hover': __assign({ bgcolor: 'grey.50' }, (previewUrl ? { borderColor: 'grey.400' } : {})),
                    '&:hover [data-dash]': {
                        strokeDashoffset: 4,
                    },
                })) }, { children: [_jsx(Box, __assign({ "aria-hidden": 'true', sx: {
                            position: 'absolute',
                            inset: 0,
                            pointerEvents: 'none',
                            color: previewUrl ? 'transparent' : 'grey.400',
                        } }, { children: _jsx("svg", __assign({ fill: 'none', style: { position: 'absolute', inset: 0, width: '100%', height: '100%', overflow: 'visible' } }, { children: _jsx("rect", { "data-dash": true, x: '1', y: '1', rx: '3', ry: '3', stroke: 'currentColor', strokeWidth: '1.5', strokeDasharray: '6 6', strokeDashoffset: '0', strokeLinecap: 'round', style: {
                                    width: 'calc(100% - 2px)',
                                    height: 'calc(100% - 2px)',
                                    transition: 'stroke-dashoffset 300ms ease',
                                } }) })) })), dragActive &&
                        _jsx(Box, { "aria-hidden": 'true', sx: function (theme) { return ({
                                position: 'absolute',
                                inset: 0,
                                pointerEvents: 'none',
                                borderRadius: 1,
                                border: '2px solid',
                                borderColor: 'primary.main',
                                bgcolor: alpha(theme.palette.primary.main, 0.06),
                            }); } }), previewUrl ? (_jsx(Box, __assign({ sx: __assign(__assign(__assign({ maxWidth: '100%', maxHeight: '100%' }, (previewAspect && fieldAspect
                            ? previewAspect >= fieldAspect
                                ? { width: '100%', aspectRatio: "".concat(previewAspect) }
                                : { height: '100%', aspectRatio: "".concat(previewAspect) }
                            : {})), { backgroundPosition: '0 0, 0 6px, 6px -6px, -6px 0', backgroundSize: '12px 12px', border: '1px solid', borderColor: 'grey.200', borderRadius: 0.75, boxSizing: 'border-box', overflow: 'hidden', pointerEvents: 'none' }), PREVIEW_BACKGROUND_STYLES[previewBackground]) }, { children: _jsx("img", { src: previewUrl, alt: '', onLoad: function (e) {
                                var _a = e.currentTarget, naturalWidth = _a.naturalWidth, naturalHeight = _a.naturalHeight;
                                if (naturalWidth && naturalHeight)
                                    setPreviewAspect(naturalWidth / naturalHeight);
                            }, style: {
                                width: previewAspect && fieldAspect ? '100%' : 'auto',
                                height: previewAspect && fieldAspect ? '100%' : 'auto',
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain',
                                display: 'block',
                            } }) }))) : compact ? (_jsxs(Stack, __assign({ gap: 0.75, alignItems: 'center', sx: { color: 'text.secondary', pointerEvents: 'none' } }, { children: [_jsx(AddPhotoAlternateOutlinedIcon, { sx: { fontSize: 28 } }), _jsx(Typography, __assign({ variant: 'body1' }, { children: t('Add image') }))] }))) : (_jsxs(Stack, __assign({ gap: 1.5, alignItems: 'center', sx: { color: 'text.secondary', pointerEvents: 'none', px: 3 } }, { children: [_jsx(AddPhotoAlternateOutlinedIcon, { sx: { fontSize: 36 } }), _jsxs(Typography, __assign({ variant: 'body1', align: 'center' }, { children: [t('Drag and drop image here or click to'), ' ', _jsx(Box, __assign({ component: 'span', sx: {
                                            textDecoration: 'underline',
                                            textUnderlineOffset: 3,
                                        } }, { children: t('browse files') }))] })), _jsx(Stack, __assign({ direction: 'row' }, { children: allowedTypes.map(function (type) { return (_jsx(Chip, { label: type, size: 'small' }, type)); }) }))] }))), previewUrl && !uploading &&
                        _jsx(Tooltip, __assign({ title: t('Change preview background') }, { children: _jsx(IconButton, __assign({ size: 'small', "aria-label": t('Change preview background'), onClick: function (e) {
                                    e.stopPropagation();
                                    cyclePreviewBackground();
                                }, sx: __assign(__assign({}, previewActionSx), { position: 'absolute', top: previewActionInset, left: previewActionInset }) }, { children: _jsx(OpacityIcon, { fontSize: 'small' }) })) })), previewUrl && !uploading &&
                        _jsxs(Stack, __assign({ direction: 'row', gap: 0.5, sx: { position: 'absolute', top: previewActionInset, right: previewActionInset } }, { children: [_jsx(Tooltip, __assign({ title: t('View image fullscreen') }, { children: _jsx(IconButton, __assign({ size: 'small', "aria-label": t('View image fullscreen'), onClick: function (e) {
                                            e.stopPropagation();
                                            setFullPreviewOpen(true);
                                        }, sx: previewActionSx }, { children: _jsx(FullscreenIcon, { fontSize: 'small' }) })) })), !isDisabled &&
                                    _jsx(IconButton, __assign({ size: 'small', "aria-label": t('Remove image'), onClick: function (e) {
                                            e.stopPropagation();
                                            setImage === null || setImage === void 0 ? void 0 : setImage(undefined);
                                        }, sx: previewActionSx }, { children: _jsx(DeleteOutlineIcon, { fontSize: 'small' }) }))] })), uploading && !source &&
                        _jsx(Box, __assign({ sx: {
                                position: 'absolute',
                                inset: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                bgcolor: function (theme) { return alpha(theme.palette.background.paper, 0.72); },
                            } }, { children: _jsx(CircularProgress, { size: 28 }) }))] })), _jsx("input", { ref: inputRef, type: 'file', accept: acceptedFileTypes, hidden: true, disabled: isDisabled || uploading, onChange: function (e) {
                    var _a;
                    var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                    if (file)
                        openFile(file);
                } }), cropDialog, discardDialog, fullPreviewDialog] }));
};
export default ImageUploadField;
